import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";

// Icons
import { FaUserShield, FaIdCard, FaCreditCard,  FaLaptopCode, FaShareAlt, FaDatabase, FaCookieBite, FaLock, FaUserCheck, FaExternalLinkAlt, FaSyncAlt, FaPhoneAlt } from "react-icons/fa";

export default function Privacy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbarsticky />

      {/*  Section */}
      <div className="privacy-container">
      </div>

      <div className="privacy-section py-5 w-100">
         <h4 className="privacy-title">
          <FaUserShield className="title-icon" /> Privacy Policy  
        </h4>
        <Container fluid className="w-100">
          <Row className="justify-content-center">
            <Col lg={9} md={11}>
              <div className="privacy-card">

                <p>
                  <p className="privacy-subtitle">Last Updated: On</p>
                  <strong>https://andamanmakeholidays.com,</strong> (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or
                  &ldquo;us&rdquo;) is committed to protecting your privacy...
                </p>

                {/* Section 1 */}
                <div className="privacy-block">
                  <h4>
                    <FaIdCard className="block-icon" />
                    Information We Collect
                  </h4>

                  <p>We collect the following types of information:</p>

                  <h5 className="sub-heading">
                    <FaUserCheck className="bullet-icon" /> Personal Information
                  </h5>

                  <ul>
                    <li>Full name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>Billing address</li>
                    <li>Government-issued ID</li>
                    <li>Passport/visa details</li>
                  </ul>

                  <h5 className="sub-heading">
                    <FaCreditCard className="bullet-icon" /> Payment Information
                  </h5>

                  <ul>
                    <li>Credit/debit card details</li>
                    <li>Transaction history</li>
                    <li>We do not store card data</li>
                  </ul>

                  <h5 className="sub-heading">
                    <FaLaptopCode className="bullet-icon" /> Technical Information
                  </h5>

                  <ul>
                    <li>IP address</li>
                    <li>Browser type</li>
                    <li>Device information</li>
                    <li>Location (if enabled)</li>
                    <li>Cookies & usage data</li>
                  </ul>
                </div>

                {/* Section 2 */}
                <div className="privacy-block">
                  <h4>
                    <FaShareAlt className="block-icon" />
                    How We Use Your Information
                  </h4>

                  <p>Your information is used to:</p>
                  <ul>
                    <li>Process bookings & payments</li>
                    <li>Send booking confirmations</li>
                    <li>Customer support</li>
                    <li>Personalize user experience</li>
                    <li>Marketing (with consent)</li>
                    <li>Legal compliance</li>
                  </ul>
                </div>

                {/* Section 3 */}
                <div className="privacy-block">
                  <h4>
                    <FaShareAlt className="block-icon" />
                    Sharing Your Information
                  </h4>

                  <p>We may share your information with:</p>
                  <ul>
                    <li><strong>Travel Partners:</strong> Hotels, transport</li>
                    <li><strong>Payment Processors:</strong> For secure transactions</li>
                    <li><strong>Legal Authorities:</strong> If required</li>
                    <li><strong>Service Providers:</strong> IT, analytics</li>
                  </ul>
                  <p><strong>We do not sell or rent your personal data.</strong></p>
                </div>

                {/* Section 4 */}
                <div className="privacy-block">
                  <h4>
                    <FaDatabase className="block-icon" />
                    Data Retention
                  </h4>

                  <p>We retain your personal data for:</p>
                  <ul>
                    <li>Legal requirements</li>
                    <li>Dispute resolution</li>
                    <li>Contract enforcement</li>
                  </ul>
                </div>

                {/* Section 5 */}
                <div className="privacy-block">
                  <h4>
                    <FaCookieBite className="block-icon" />
                    Cookies & Tracking
                  </h4>

                  <ul>
                    <li>Enhance functionality</li>
                    <li>Analyze traffic</li>
                    <li>Remember preferences</li>
                    <li>Provide targeted ads</li>
                  </ul>
                </div>

                {/* Section 6 */}
                <div className="privacy-block">
                  <h4>
                    <FaLock className="block-icon" />
                    Data Security
                  </h4>

                  <ul>
                    <li>SSL encryption</li>
                    <li>Secure servers</li>
                    <li>Regular assessments</li>
                  </ul>
                </div>

                {/* Section 7 */}
                <div className="privacy-block">
                  <h4>
                    <FaUserCheck className="block-icon" />
                    Your Rights
                  </h4>

                  <ul>
                    <li>Access your data</li>
                    <li>Request correction or deletion</li>
                    <li>Withdraw marketing consent</li>
                    <li>File complaint</li>
                  </ul>

                  <p>Email: andamanmakeholidayss@gmail.com</p>
                </div>

                {/* Section 8 */}
                <div className="privacy-block">
                  <h4>
                    <FaUserShield className="block-icon" />
                    Children’s Privacy
                  </h4>

                  <p>We do not collect data from individuals under 18.</p>
                </div>

                {/* Section 9 */}
                <div className="privacy-block">
                  <h4>
                    <FaExternalLinkAlt className="block-icon" />
                    Third-Party Links
                  </h4>

                  <p>We are not responsible for external website policies.</p>
                </div>

                {/* Section 10 */}
                <div className="privacy-block">
                  <h4>
                    <FaSyncAlt className="block-icon" />
                    Changes to This Policy
                  </h4>

                  <p>We may update this policy periodically.</p>
                </div>

                {/* Section 11 */}
                <div className="privacy-block">
                  <h4>
                    <FaPhoneAlt className="block-icon" />
                    Contact Us
                  </h4>

                  <p>Email: andamanmakeholidayss@gmail.com</p>
                  <p>Phone: +91-8145080001</p>
                  <p>Andaman Make Holidays</p>
                  <p>Near Park Hotel Beadnabd, Sri Vijay Puram</p>
                  <p>Andaman & Nicobar Islands - 744105</p>
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Footer />
    </>
  );
}
